import { Maybe } from 'maybeasy';
import { useEffect, useState } from 'react';
import { assertNever } from '../../../../../Decoders';
import { emptyFragment } from '../../../../../EmptyFragment';
import type { Link } from '../../../../../Resource/Types';

// DVLP-7601: the uploaded collection logo in the preview, mirroring the
// participant page's CollectionLogo (platform3/src/Native/AEP/Common/
// CollectionLogo, DVLP-7805): the column exists only while the image is
// showing, and drops entirely when the asset fails to load, so the
// description takes the full width exactly when it would for a participant.

interface Showing {
  kind: 'showing';
}

interface Failed {
  kind: 'failed';
}

type LogoState = Showing | Failed;

interface Props {
  link: Maybe<Link>;
}

function PreviewCollectionLogo({ link }: Props) {
  const [state, setState] = useState<LogoState>({ kind: 'showing' });
  const href = link.map(({ href }) => href);

  // A different collection deserves a fresh attempt.
  const key = href.getOrElseValue('');
  useEffect(() => setState({ kind: 'showing' }), [key]);

  switch (state.kind) {
    case 'failed':
      return emptyFragment();
    case 'showing':
      return href
        .map((src) => (
          <div
            key={src}
            className="mt-4 w-full max-w-xs overflow-hidden md:basis-1/4 md:max-w-[25%] md:shrink-0 md:grow-0"
            data-intercom-target="preview-collection-logo"
          >
            <img
              className="h-auto max-h-48 max-w-full object-contain"
              src={src}
              alt=""
              onError={() => setState({ kind: 'failed' })}
            />
          </div>
        ))
        .getOrElse(emptyFragment);
  }
  return assertNever(state);
}

export default PreviewCollectionLogo;
